var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallBusiness100X90100X90(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "90px",
    viewBox: "0 0 100 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/small-business/color/100x90") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/small-business/color/100x90",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "store",
    transform: "translate(4, 9)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9EAEB",
    x: 6.70490039,
    y: 12.4887331,
    width: 79.5894727,
    height: 66.4600844
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    x: 76.1909766,
    y: 12.4887331,
    width: 10.104668,
    height: 66.4600844
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5728281,12.4882014 L6.42717188,12.4882014 L6.42717188,1.57821436 C6.42717188,0.706528255 7.15137305,0 8.04486328,0 L84.9551367,0 C85.848627,0 86.5728281,0.706528255 86.5728281,1.57821436 L86.5728281,12.4882014 Z",
    id: "Path",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9551367,0 L76.4681602,0 L76.4681602,8.2130587 L86.5728281,8.2130587 L86.5728281,1.57821436 C86.5728281,0.706705463 85.848627,0 84.9551367,0 Z",
    id: "Path",
    fill: "#E2791B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70490039,32.2720558 L6.70490039,32.2720558 C3.04193555,32.2720558 0.0722929688,29.3750596 0.0722929688,25.8014833 L0.0722929688,20.5299 L13.3373262,20.5299 L13.3373262,25.8014833 C13.3375078,29.3750596 10.3678652,32.2720558 6.70490039,32.2720558 Z",
    id: "Path",
    fill: "#C60E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9699336,32.2720558 L19.9699336,32.2720558 C16.3069688,32.2720558 13.3373262,29.3750596 13.3373262,25.8014833 L13.3373262,20.5299 L26.6023594,20.5299 L26.6023594,25.8014833 C26.602541,29.3750596 23.6328984,32.2720558 19.9699336,32.2720558 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2349668,32.2720558 L33.2349668,32.2720558 C29.572002,32.2720558 26.6023594,29.3750596 26.6023594,25.8014833 L26.6023594,20.5299 L39.8673926,20.5299 L39.8673926,25.8014833 C39.8675742,29.3750596 36.8979316,32.2720558 33.2349668,32.2720558 Z",
    id: "Path",
    fill: "#C60E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5,32.2720558 L46.5,32.2720558 C42.8370352,32.2720558 39.8673926,29.3750596 39.8673926,25.8014833 L39.8673926,20.5299 L53.1324258,20.5299 L53.1324258,25.8014833 C53.1324258,29.3750596 50.1629648,32.2720558 46.5,32.2720558 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7650332,32.2720558 L59.7650332,32.2720558 C56.1020684,32.2720558 53.1324258,29.3750596 53.1324258,25.8014833 L53.1324258,20.5299 L66.397459,20.5299 L66.397459,25.8014833 C66.3976406,29.3750596 63.427998,32.2720558 59.7650332,32.2720558 Z",
    id: "Path",
    fill: "#C60E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0300664,32.2720558 L73.0300664,32.2720558 C69.3671016,32.2720558 66.397459,29.3750596 66.397459,25.8014833 L66.397459,20.5299 L79.6624922,20.5299 L79.6624922,25.8014833 C79.6626738,29.3750596 76.6930312,32.2720558 73.0300664,32.2720558 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2950996,32.2720558 L86.2950996,32.2720558 C82.6321348,32.2720558 79.6624922,29.3750596 79.6624922,25.8014833 L79.6624922,20.5299 L92.9275254,20.5299 L92.9275254,25.8014833 C92.927707,29.3750596 89.9580645,32.2720558 86.2950996,32.2720558 Z",
    id: "Path",
    fill: "#C60E68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F41381",
    points: "13.3373262 20.5297228 0.0722929688 20.5297228 6.42045117 8.2130587 17.8718027 8.2130587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "26.6023594 20.5297228 13.3373262 20.5297228 17.8718027 8.2130587 29.3229727 8.2130587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F41381",
    points: "39.8673926 20.5297228 26.6023594 20.5297228 29.3229727 8.2130587 40.7743242 8.2130587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "53.1324258 20.5297228 39.8673926 20.5297228 40.7743242 8.2130587 52.2256758 8.2130587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F41381",
    points: "66.397459 20.5297228 53.1324258 20.5297228 52.2256758 8.2130587 63.6770273 8.2130587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "79.6624922 20.5297228 66.397459 20.5297228 63.6770273 8.2130587 75.1281973 8.2130587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F41381",
    points: "92.9275254 20.5297228 79.6624922 20.5297228 75.1281973 8.2130587 86.5795488 8.2130587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9707793,72.8762541 L3.0292207,72.8762541 C1.35631055,72.8762541 0,74.199289 0,75.8315518 L0,80.1623378 C0,80.6250279 0.384533203,81 0.858615234,81 L92.1412031,81 C92.6154668,81 92.9998184,80.6248507 92.9998184,80.1623378 L92.9998184,75.8315518 C92.9998184,74.199289 91.6436895,72.8762541 89.9707793,72.8762541 Z",
    id: "Path",
    fill: "#8B8892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9707793,72.8762541 L82.8642715,72.8762541 L82.8642715,81 L92.1413848,81 C92.6156484,81 93,80.6250279 93,80.1623378 L93,75.8315518 C93,74.199289 91.6436895,72.8762541 89.9707793,72.8762541 Z",
    id: "Path",
    fill: "#8B8892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4556719,64.1904045 L37.602334,64.1904045 C36.9357129,64.1904045 36.395332,63.6632107 36.395332,63.0128574 L36.395332,41.0814194 C36.395332,40.4310661 36.9357129,39.9038723 37.602334,39.9038723 L78.4556719,39.9038723 C79.122293,39.9038723 79.6626738,40.4310661 79.6626738,41.0814194 L79.6626738,63.0130346 C79.6626738,63.6632107 79.122293,64.1904045 78.4556719,64.1904045 Z",
    id: "Path",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4556719,39.9038723 L69.5267637,39.9038723 L69.5267637,64.1904045 L78.4556719,64.1904045 C79.122293,64.1904045 79.6626738,63.6632107 79.6626738,63.0128574 L79.6626738,41.0814194 C79.6626738,40.4310661 79.122293,39.9038723 78.4556719,39.9038723 Z",
    id: "Path",
    fill: "#067A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6574863,72.8762541 L12.018252,72.8762541 L12.018252,41.0814194 C12.018252,40.4310661 12.5586328,39.9038723 13.2252539,39.9038723 L29.4504844,39.9038723 C30.1171055,39.9038723 30.6574863,40.4310661 30.6574863,41.0814194 L30.6574863,72.8762541 L30.6574863,72.8762541 Z",
    id: "Path",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4504844,39.9038723 L20.5215762,39.9038723 L20.5215762,72.8762541 L30.6573047,72.8762541 L30.6573047,41.0814194 C30.6574863,40.4310661 30.1171055,39.9038723 29.4504844,39.9038723 Z",
    id: "Path",
    fill: "#875EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4487598,58.5282548 C26.2238203,58.5282548 26.8521152,57.9152924 26.8521152,57.1591459 L26.8521152,54.6947144 C26.8521152,53.9385679 26.2238203,53.3256055 25.4487598,53.3256055 C24.6736992,53.3256055 24.0454043,53.9385679 24.0454043,54.6947144 L24.0454043,57.1591459 C24.0452227,57.9152924 24.6736992,58.5282548 25.4487598,58.5282548 Z",
    id: "Path",
    fill: "#F41381"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBusiness100X90100X90);
export default __webpack_public_path__ + "static/media/small-business_100x90100x90.52a26f29b12be6d6918a04866fe346d7.svg";
export { ForwardRef as ReactComponent };